// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"70d93f4b","363":"26ffb37c","597":"1f84851c","700":"5dc2c841"}[chunkId] + ".chunk.js";
};